import React from 'react'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import { useAzureRole, useTargetPerson } from 'hooks'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import AzureRbacRoleDetails from './AzureRbacRoleDetails'

const AzureRbacRolesDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()

    const { data: azureRbacRole } = useAzureRole(id, targetPerson?.id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={azureRbacRole?.friendlyName} />
            {!azureRbacRole && <Loader />}
            {azureRbacRole && (
                <AzureRbacRoleDetails
                    toggleDrawer={toggleDrawer}
                    attributes={attributes}
                    azureRbacRole={azureRbacRole}
                />
            )}
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            header={<ItemHeader title={azureRbacRole?.friendlyName} />}
            closeOnOutsideClick
        >
            {!azureRbacRole && <Loader />}
            {azureRbacRole && (
                <AzureRbacRoleDetails
                    toggleDrawer={toggleDrawer}
                    attributes={attributes}
                    azureRbacRole={azureRbacRole}
                />
            )}
        </Drawer>
    )
}

export default AzureRbacRolesDrawer
